import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class DownloadFileInputModel {
  @ApiPropertyOptional()
  @IsOptional()
  @IsString()
  public attachment?: string;

  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  public name!: string;
}
